<template>
    <transition name="component-fade" mode="out-in">
        <div class="card noselect"
             :class="[hovered ? 'shadow-lg' : 'shadow-sm', pageLinkEnabled ? 'cursor-pointer' : '', hoverEffectEnabled ? 'card-hover' : '']"
             @mouseenter="hovered = true"
             @mouseleave="hovered = false"
             @click="cardClicked"
            v-if="video !== null"
        >


            <!-- Kiss Video Image -->
            <img class="card-img-top rounded" :src="video.kiss_video.thumbnail_url" :alt="video.title[$i18n.locale]" @load="imageLoaded = true" v-if="thumbnailEnabled && kissVideoExisting"/>

            <!-- Placeholder if Kiss Video not available -->
            <img class="card-img-top rounded" src="https://placehold.it/400x200?text=Video+not+available" @load="imageLoaded = true" v-if="thumbnailEnabled && (!kissVideoExisting)"/>


            <!-- Loading indicator if image is not loaded -->
            <div class="text-center bg-light" v-if="!imageLoaded && thumbnailEnabled" style="padding-top: 80px; padding-bottom: 80px;">
                <i class="mdi mdi-spin mdi-autorenew mdi-36px text-primary"></i>
            </div>


            <div>
                <div class="progress radius-none" v-if="startedWatching && showProgress" style="margin-bottom: -10px">
                    <div class="progress-bar bg-primary radius-none" role="progressbar" :style="'width: ' + percentageWatched + '%'" :aria-valuenow="percentageWatched" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="card-body p-4">
                    <h5 class="card-text">{{ videoTitle }}</h5>
                    <div class="mb-5">
                        <span class="text-muted" :title="$date(video.published_at).format('DD.MM.YYYY HH:mm')">
                            <i class="mdi mdi-calendar"></i>
                            {{ $date(video.published_at).fromNow() }}
                        </span>
                    </div>
                    <gym-video-level-badge :level="video.level" :label="video.localized_level"/>
                    <gym-video-intensity-badge :intensity="video.intensity"/>
                    <gym-video-duration-badge :duration="video.duration"/>
                </div>

                <slot name="footer">
                    <div class="card-footer pl-4 pr-4" v-if="showLike || showCompleted">
                        <div class="row mt-2">
                            <div class="col" v-if="showLike">
                                <i class="mdi mdi-24px" :class="[isVideoFavored ? 'text-primary mdi-heart' : 'mdi-heart-outline text-muted']"></i>
                            </div>
                            <div class="col text-right" v-if="showCompleted">
                                <i class="mdi mdi-24px text-primary mdi-check-decagram" v-if="watchedEntirely"></i>
                            </div>
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </transition>
</template>

<script>
import GymVideoLevelBadge from "./Badges/GymVideoLevelBadge";
import GymVideoIntensityBadge from "./Badges/GymVideoIntensityBadge";
import GymVideoDurationBadge from "./Badges/GymVideoDurationBadge";
export default {
    name: "GymVideoCard",
    components: {GymVideoDurationBadge, GymVideoIntensityBadge, GymVideoLevelBadge},
    props: {
        video: {
            type: Object,
            required: true
        },
        showProgress: {
            type: Boolean,
            default: true
        },
        showLike: {
            type: Boolean,
            default: true
        },
        showCompleted: {
            type: Boolean,
            default: true
        },
        hoverEffectEnabled: {
            type: Boolean,
            default: true
        },
        pageLinkEnabled: {
            type: Boolean,
            default: false
        },
        thumbnailEnabled: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        hovered: false,
        imageLoaded: false
    }),
    methods: {
        cardClicked() {
            if(!this.pageLinkEnabled)
                return false;

            this.$router.push({name: 'gym.video', params: {video: this.video.id}});
        }
    },
    computed: {
        videoTitle() {
            if(this.video.title[this.$i18n.locale] === null) {
                if(this.video.title["en"] !== null)
                    return this.video.title["en"]
                else
                    return this.video.title.find(t => t !== null) || "???";
            }

            return this.video.title[this.$i18n.locale];
        },
        kissVideoExisting() {
            return this.video.kiss_video !== undefined && this.video.kiss_video !== null;
        },
        startedWatching() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.playtime !== 0;
        },
        percentageWatched() {
            if(!this.startedWatching)
                return 0;

            let videoLength = this.video.length;
            let secondsWatched = this.video.user.playtime;

            return (secondsWatched / videoLength) * 100;
        },
        watchedEntirely() {
            if(!this.startedWatching)
                return false;

            return this.video.user.completed;
        },
        isVideoFavored() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.favored;
        }
    }
}
</script>

<style scoped>
    .card-img-top {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    .card {
        transition: transform 0.5s;
        transform: scale(1);
    }
    .card-hover:hover {
        transition: transform 0.5s;
        transform: scale(1.04);
        z-index: 999;
    }
</style>
